export class ValidationConstants {
    // Validations
  public static VALIDATION_INPUT_PRICE_UNIT_NAME_MAX_LENGTH = 200;
  public static VALIDATION_INPUT_PHOTOGRAPHY_TYPE_NAME_MAX_LENGTH = 200;

  public static PHOTOGRAPHY_TYPE_ICON_MAX_HEIGHT = 200;
  public static PHOTOGRAPHY_TYPE_ICON_MAX_WIDTH = 200;

  public static IMAGE_PREVIEW_SIZE_WIDTH = 1280;
  public static IMAGE_PREVIEW_SIZE_HEIGHT = 720;
  public static COMPANY_TITLE_MAX_LENGTH = 100;
  public static COMPANY_DESCRIPTION_MAX_LENGTH = 450;

  public static DEPARTMENT_NAME_MAX_LENGTH = 100;
  public static DEPARTMENT_CODE_MAX_LENGTH = 25;

  public static ISSUE_TYPE_NAME_MAX_LENGTH = 100;

  public static UPLOAD_IMAGE_MAX_SIZE_HINT = '5MB';
  public static UPLOAD_IMAGE_MAX_SIZE_KB = 5242880;
  public static UPLOAD_IMAGE_MAX_SIZE_MB = 2000000;
  public static UPLOAD_IMAGE_MAX_SIZE_BYTE = 10485760;
  public static UPLOAD_IMAGE_FILE_TYPE = ['image/png', 'image/jpeg', 'image/jpg'];
  public static UPLOAD_IMAGE_COUNT_LIMIT = 10;

  public static UPLOAD_ATTACHMENT_MAX_SIZE_MB = 2000000;
}
